import { UserDto } from './user.dto';

export class User {
    id: string;
    email: string;
    firstname: string;
    lastname: string;
    permissions: string[];
    hasPermissionsWildcard: boolean;

    constructor(data: UserDto) {
        this.id = data.id;
        this.email = data.email ?? '';
        this.firstname = data.firstname ?? '';
        this.lastname = data.lastname ?? '';
        this.permissions = data.permissions;
        this.hasPermissionsWildcard = data.hasPermissionsWildcard;
    }
}
